// import this after install `@mdi/font` package
import VueLazyload from 'vue-lazyload';
import showdown from 'showdown';
import '@mdi/font/css/materialdesignicons.css';
import applicationConfig from '../../config/application.json';
import packageJson from '../../package.json';
declare module '#app' {
  interface NuxtApp {
    $t: Function;
  }
}
const WindowSize = reactive({
  x: 0,
  y: 0,
  s: 0,
  halfX: 0,
  init(): void {
    WindowSize.onResize();
    if (process.client) {
      setInterval(() => this.s++, 1000);
    }
    if (import.meta.client) {
      watch(() => WindowSize.s, () => {
        WindowSize.x = window.innerWidth;
        WindowSize.halfX = Math.round(window.innerWidth / 2);
        WindowSize.y = window.innerHeight;
      });
    }
  },
  onResize(): void {
    if (process.client) {
      WindowSize.x = window.innerWidth;
      WindowSize.y = window.innerHeight;
    }
  },
  isMobile(): boolean {
    if (process.client) {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent,
        )
      ) {
        return true;
      } else {
        return false;
      }
    }
    return false;
  },
});




export default defineNuxtPlugin(async (app) => {
  const { $i18n } = useNuxtApp();
  const converter = new showdown.Converter();
  const VueLazyLoadInit = (VueLazyload?.default) ? VueLazyload.default : VueLazyload;

  app.vueApp.use(VueLazyLoadInit, {
    observer: true,
    filter: {
      progressive(listener: any) {
        // load low quality image
        listener.loading = listener.src?.replace(/\/\d+x\d+\//, '/20x0/');
        listener.loading = listener.loading + '?quality=1';
        listener.el.setAttribute('lazy-progressive', 'true');
      },
    },
  });

  WindowSize.init();

  return {
    provide: {
      // @ts-ignore
      t: (...args): string => {
        if (!args[0]) return '';
        // @ts-ignore
        return $i18n.t(...args);
      },
      md: converter,
      windowSize: WindowSize,
    },
  };
});
